import {Component, OnInit} from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'sigecom-footer',
  template: `
    <footer class="footer bg-cbde-dark-blue p-4"
      [ngClass]="{
        'bg-gradiente-dev': environment.versionTag === 'DEV',
        'bg-gradiente-hml': environment.versionTag === 'HML',
        'bg-gradiente-prd': environment.versionTag === 'PRD' || environment.versionTag === 'LOCAL',
        'text-white': environment.versionTag !== 'DEV',
        'text-black': environment.versionTag === 'HML' || environment.versionTag === 'PRD',
      }"
    >
      <p class="text-center text-sm">
        Copyright © 2021 - Confederação Brasileira de Desporto Escolar
      </p>
    </footer>
  `,
})
export class FooterComponent implements OnInit {
  public sidenav = false;

  protected readonly environment = environment;

  constructor() {
  }

  ngOnInit() {
  }

}
